import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { cleanColisCode } from '../utils/helpers';

export default function ColisDetailsPage() {
  const [params] = useSearchParams();
  const rawCode = (params.get('code') || '').trim();
  const code = cleanColisCode(rawCode);

  if (code) {
    return <Navigate to={`/suivi?code=${encodeURIComponent(code)}`} replace />;
  }

  return <Navigate to="/suivi" replace />;
}
